import React from "react";
import styled from "styled-components";
import { GrRotateRight } from "react-icons/gr";

const LoaderSec = styled.div`
  > svg {
    animation: rotateLoader 1s infinite linear;
  }
`;

const ButtonLoader = () => {
  return (
    <LoaderSec>
      <GrRotateRight />
    </LoaderSec>
  );
};

export default ButtonLoader;
